export default {
  meta: {
    title: '文章列表'
  }
};
